export const style = {
  container: {
    p: 2,
    display: "flex",
    flexDirection: "column",
  },
  heading: {
    textAlign: "center",
    mb: 2,
  },
  myOrdersCars: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    flexDirection: "row",
    gap: 2,
  },
};
